import { Autocomplete } from '../../1elements'
import { useEffect, useState } from 'react'
import ApiService from '../../../common/ApiCalls'

const searchStyles = {
  padding: 0,
  width: '40%'
}
const inputStyles = { padding: '5px 13px' }

const LocationSearchByEndCustomerName = ({ selectedLocation, setSelectedLocation, validation, disabled, endCustomerName }) => {
  const [searchWord, setSearchWord] = useState('')
  const [options, setOptions] = useState([])
  const updateSearchWord = (e) => {
    setSearchWord(e.target.value)
  }
  useEffect(() => {
    if (searchWord.length > 0) {
      ApiService().searchLocationByEndCustomerName(searchWord, endCustomerName)
        .then((res) => {
          setOptions(res.data)
        })
        .catch((err) => {
          console.log('There was an error on searchLocationByAccountName: ', err)
        })
    } else {
      setOptions([])
    }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [searchWord])

  return (
    <Autocomplete
      inputRootSx={searchStyles} inputStyle={inputStyles} value={selectedLocation} onChangeTextField={updateSearchWord}
      options={options} onChangeAutocomplete={setSelectedLocation} validation={validation} showError={validation}
      optionLabel='name' disabled={disabled}
    />
  )
}

export default LocationSearchByEndCustomerName
